var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_143_1",
    "data-name": "Component 143 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-svgrepo-com",
    transform: "translate(5 5.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 2,
    height: 9,
    transform: "translate(8 7.948)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 2,
    height: 9,
    transform: "translate(12 7.948)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M4,6V7.372H5.372V21.089a1.372,1.372,0,0,0,1.372,1.372H17.718a1.372,1.372,0,0,0,1.372-1.372V7.372h1.372V6ZM6.744,21.089V7.372H17.718V21.089Z",
    transform: "translate(-1.256 -1.885)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 6,
    height: 2,
    transform: "translate(8 0.948)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 22,
    height: 22,
    transform: "translate(0 -0.052)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGray);
export default __webpack_public_path__ + "static/media/Delete_gray.d539dd665d35580d804fb38d39620511.svg";
export { ForwardRef as ReactComponent };